var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BCtrend",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-40.000000, -210.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.28571429,7.14285714 C5.0746925,7.14285714 5.71428571,7.78245036 5.71428571,8.57142857 L5.71428571,15.7142857 C5.71428571,16.5032639 5.0746925,17.1428571 4.28571429,17.1428571 L1.42857143,17.1428571 C0.639593215,17.1428571 0,16.5032639 0,15.7142857 L0,8.57142857 C0,7.78245036 0.639593215,7.14285714 1.42857143,7.14285714 L4.28571429,7.14285714 Z M11.4285714,0 C12.2175496,0 12.8571429,0.639593215 12.8571429,1.42857143 L12.8571429,15.7142857 C12.8571429,16.5032639 12.2175496,17.1428571 11.4285714,17.1428571 L8.57142857,17.1428571 C7.78245036,17.1428571 7.14285714,16.5032639 7.14285714,15.7142857 L7.14285714,1.42857143 C7.14285714,0.639593215 7.78245036,0 8.57142857,0 L11.4285714,0 Z M18.5714286,2.85714286 C19.3604068,2.85714286 20,3.49673607 20,4.28571429 L20,15.7142857 C20,16.5032639 19.3604068,17.1428571 18.5714286,17.1428571 L15.7142857,17.1428571 C14.9253075,17.1428571 14.2857143,16.5032639 14.2857143,15.7142857 L14.2857143,4.28571429 C14.2857143,3.49673607 14.9253075,2.85714286 15.7142857,2.85714286 L18.5714286,2.85714286 Z M4.28571429,8.57142857 L1.42857143,8.57142857 L1.42857143,15.7142857 L4.28571429,15.7142857 L4.28571429,8.57142857 Z M11.4285714,1.42857143 L8.57142857,1.42857143 L8.57142857,15.7142857 L11.4285714,15.7142857 L11.4285714,1.42857143 Z M18.5714286,4.28571429 L15.7142857,4.28571429 L15.7142857,15.7142857 L18.5714286,15.7142857 L18.5714286,4.28571429 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.714285714,18.5714286 L19.2857143,18.5714286 C19.7619048,18.5714286 20,18.8095238 20,19.2857143 L20,19.2857143 C20,19.7619048 19.7619048,20 19.2857143,20 L0.714285714,20 C0.238095238,20 0,19.7619048 0,19.2857143 L0,19.2857143 C0,18.8095238 0.238095238,18.5714286 0.714285714,18.5714286 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.7e884687409af11d24fed8ac488324df.svg";
export { ForwardRef as ReactComponent };